import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-exception.stack.js";
import axios from 'axios';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { onMounted } from 'vue';
export default {
  name: 'App',
  setup() {
    const store = useStore();
    const router = useRouter();

    // 检查并续订token
    const checkAndRefreshToken = async () => {
      const token = store.getters.token;

      // 如果没有token，跳过检查
      if (!token) {
        return;
      }
      try {
        // 解析token获取过期时间
        const tokenParts = token.split('.');
        if (tokenParts.length !== 3) {
          console.warn('Token格式无效');
          store.dispatch('logout');
          return;
        }

        // JWT使用URL-safe的Base64编码，需要转换为标准Base64
        const base64Url = tokenParts[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const payload = JSON.parse(atob(base64));
        const exp = payload.exp; // token过期时间（秒）
        const now = Math.floor(Date.now() / 1000); // 当前时间（秒）

        // 计算剩余时间（小时）
        const remainingHours = (exp - now) / 3600;

        // 如果token已过期，清除并跳转到登录页
        if (remainingHours <= 0) {
          console.warn('Token已过期，请重新登录');
          store.dispatch('logout');
          router.push('/login');
          return;
        }
        const response = await axios.post('/api/auth/refresh');
        if (response.data.success && response.data.token) {
          const newToken = response.data.token;
          store.dispatch('login', newToken);
        }
      } catch (error) {
        console.error('Token检查失败:', error);

        // 如果token无效或已过期，清除并跳转到登录页
        if (error.response && error.response.status === 401) {
          console.warn('Token无效，请重新登录');
          store.dispatch('logout');
          router.push('/login');
        }
      }
    };

    // 应用启动时检查token
    onMounted(() => {
      checkAndRefreshToken();
    });
    return {};
  }
};